module.exports = __webpack_public_path__ + "static/media/LOW_ENERGY.06c53efb.svg";